// TODO(ssr-legacy-removal): Remove this CSR entry after one stable SSR release; see
// docs/features/ssr-rsc-seo/8-verification-and-docs.md.
import './trustedTypes';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import './i18n';
import { getWebPath } from './pathPrefix';
import { websiteRoutes } from './router/routes';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root was not found.');
}

const router = createBrowserRouter(websiteRoutes, {
  basename: getWebPath(),
});

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
